import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`;

const readFile = async (target_id, target_type) => {
  const { data } = await axios.get(
    `${baseUrl}/file?target_id=${target_id}&target_type=${target_type}`,
  );
  return data;
};

const createFile = async (param) => {
  const { data } = await axios.post(`${baseUrl}/file/add`, param);
  return data;
};

const editFile = async (param) => {
  const { data } = await axios.put(`${baseUrl}/file/edit`, param);
  return data;
};

const fileApi = {
  readFile,
  createFile,
  editFile,
};

export default fileApi;
